import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Meta } from '@angular/platform-browser';
import { productcards, previousproductcards, discontinued } from '../assets/products';
export interface ProductCard { title: string; subtitle: string; link: string; imgsrc: string; tag: string; text1: string; eol: string; keyword: string; "Meta Description": string; undefined: string; finderfilter: string; "UL Logo removed?"?: undefined; }
@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  productcards = productcards;
  previousproductcards = previousproductcards;
  discontinued = discontinued;
  allProducts = [...this.productcards, ...this.previousproductcards, ...this.discontinued];
  uniqueKeywords: string[] = [];
  test = [
      // {
      //     title: '',
      //     subtitle: '',
      //     link: '/products/',
      //     imgsrc: './assets/images/Products/.webp',
      //     tag: '',
      //     text1: 'PRODUCTS.',
      //     portable: 'YES',
      //     catv: '',
      //     show: 'YES',
      //     eol: '0',
      //     keyword: 'showall current ',
      //  "Meta Description":"Built for modern network deployments, it offers robust Wi-Fi testing with a spectrum analyzer covering 2.4, 5 and 6 GHz. With Internet QoE validation, it empowers technicians to diagnose, optimize and maintain high-speed Wi-Fi networks, making it essential for both residential and enterprise environments.",
      //  "finderfilter":"portable wifi show"
      // },
  ];

  constructor(
    public meta: Meta,
    ) {
        if (environment.production && environment.test) {
            const addproducts = [
              // {
              //    "title":"RXT",
              //    "subtitle":"CARDSUBTITLES.",
              //    "link":"/products/r",
              //    "imgsrc":"./assets/images/Products/test.webp",
              //    "tag":"New",
              //    "text1":"PRODUCTS.RXT6800.MAINTEXT",
              //    "eol":"0",
              //    "keyword":"showall current",
              //    "Meta Description":"",
              //    "UL Logo removed?":"n/a",
              //    "finderfilter":"show"
              // },
            ];
            for (let i = 0; i < addproducts.length; i++){
                this.productcards.unshift(addproducts[i]);
            }
            // for(let i = discontinued.length -1; i > 0; i--){
            //   const tempimg = discontinued[i].imgsrc.split('/');
            //   console.log(`${discontinued[i].title}               ${tempimg[tempimg.length - 1]}`);
              
            // }
        }
        
    }
    initProduct(product) {
        const foundProduct = this.productcards.find(element => product == element.title) || 
                            this.previousproductcards.find(element => product == element.title) || 
                            this.discontinued.find(element => product == element.title);
      
        if (foundProduct) {
        //   console.log(product, foundProduct);
          this.addTags(foundProduct);
        }
      }
      addTags(product) {
        // console.log(product);
        // console.log(this.meta.getTag('name=description'));
        // <meta property="og:image" content="https://www.veexinc.com/assets/images/header/VeEX_logo_tagline.png">
        if(product.imgsrc){
          let tempimgsrc = product.imgsrc.replace('https://www.veexinc.com', '');
          tempimgsrc = tempimgsrc.replace('./', '/');
          tempimgsrc = tempimgsrc.replace('.webp', '.jpg');
          this.meta.updateTag({ property: 'og:image', content: `https://www.veexinc.com${tempimgsrc}` });
          this.meta.updateTag({ name: 'twitter:image', content: `https://www.veexinc.com${tempimgsrc}` });
        }
        this.meta.updateTag({ name: 'title', content: `${product.title} | VeEX Inc.` });
        this.meta.updateTag({ name: 'description', content: `${product["Meta Description"]?product["Meta Description"]:product["text1"]}` });
        this.meta.updateTag({ name: 'keywords', content: `${product.keyword} ${product.finderfilter?product.finderfilter:''}` });

        this.meta.updateTag({ property: 'og:title', content: `${product.title} | VeEX Inc.` });
        this.meta.updateTag({ property: 'og:description', content: `${product["Meta Description"]?product["Meta Description"]:product["text1"]}` });
        this.meta.updateTag({ property: 'og:keywords', content: `${product.keyword} ${product.finderfilter?product.finderfilter:''}` });
        
        this.meta.updateTag({ name: 'twitter:title', content: `${product.title} | VeEX Inc.` });
        this.meta.updateTag({ name: 'twitter:description', content: `${product["Meta Description"]?product["Meta Description"]:product["text1"]}` });
        console.log(this.meta.getTag('name=title'));
        console.log(this.meta.getTag('name=description'));
        console.log(this.meta.getTag('name=keywords'));
      }
}
